import React, { Component } from 'react';
import { Modal, Button, Icon, Checkbox, AutoComplete, Select, Row, Col, message } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';

const Option = Select.Option;
class DegreeAdd extends Component {

    state = {
        visible: false,
        //addList:{"dictId":null,"type":null,"name":null,"code":"Last Site Initiation"},{"dictId":null,"type":null,"name":null,"code":"CRC Site Contract"},{"dictId":null,"type":null,"name":null,"code":"Last Patient Last Visit"}
        addList: [],
        loading: true,
        confirmLoading: false,
        stageId:'',
        stageName:'',
    };

    show = (ref) => {
        this.setState({
            visible: true
        });
        this.loadData();
    };

    hide = () => {
        this.setState({
            visible: false,
            stageId:'',
            stageName:undefined,
        });
    };

    loadData = (val) => {
        const options = {
            url: `${API_URL.plan.degreeUnuseList}`,
            data: {
                keyword: val,
            },
            dataType: 'json',
            doneResult: ( data => {
                const listData = data.datas;
                const addList = [];
                listData.map((value) => {
                    addList.push({label:value.code, value:value.dictId});
                })
                this.setState({
                    addList: addList,
                })
            }),
            failResult: ( data => {
            })
        };
        AjaxRequest.sendRequest(options);
    };

    saveAdd = () => {
        const { stageId, stageName } = this.state;
        if(!stageName){
            message.error("请选择或填写项目阶段节点");
            return; 
        }
        const options = {
            url: `${API_URL.plan.addDegreeList}`,
            data: {
                dictId :stageId,
                name: stageName,
            },
            dataType: 'json',
            doneResult: ( data => {
                this.hide();
                message.success("添加成功");
                this.props.reload();
                this.props.reRender();
            }),
            failResult: (() => {
                    this.setState({confirmLoading: false});
                }
            ),
        };
        AjaxRequest.sendRequest(options);
    };


    handleChange = (val) => {
        const { addList } = this.state;
        const option = (addList || []).find(i => i.value == val) || {};
        const { label, value } = option;
        this.setState({
            stageName: label || val,
            stageId:value,
        })
    }

    render() {
        const { visible, confirmLoading, addList, stageName } = this.state;
        const diseaseOption = (addList || []).map(d => <Option key={String(d.value)} showValue={d.label} title={d.label}>{d.label}</Option>);
        return (
            <Modal
                title="添加项目阶段节点"
                visible={visible}
                onCancel={this.hide}
                onOk={this.saveAdd}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="350px"
                confirmLoading={confirmLoading}
            >
                <div>
                     <Row type="flex" align="middle">
                            <Col span={2} style={{textAlign:'right',color:'red',verticalAlign:'middle'}}>
                            *
                            </Col>
                            <Col span={6}>项目阶段节点</Col>
                            <Col span={14}>
                            <AutoComplete
                                dataSource={diseaseOption}
                                allowClear={true}
                                style={{width:'100%'}}
                                //optionLabelProp="showValue"
                                placeholder="输入名称检索"
                                value={stageName}
                                filterOption={(inputValue, option) => option.props.children.indexOf(inputValue) >= 0}
                                onChange={value => this.handleChange(value)}
                                >
                            </AutoComplete>
                            </Col>
                        </Row>
                    
                </div>
            </Modal>
        );
    }
}

export default DegreeAdd;



// WEBPACK FOOTER //
// ./src/components/plan/DegreeAdd.js